import React from 'react'

import { Formik } from 'formik'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import { CodigosTransaccionesConstant } from 'constants/index'

import { Portlet, Form, Button, Row, Col } from '_zari/core'
import Yup from '_zari/validation/_yup'

import * as AsientoContableService from 'services/asientosContables.service'

import { DownloadAxiosFile } from 'utils'

import * as FormGroups from './formGroups'

const portletBreadcrumbs = [
  { name: 'Asientos Contables', path: `/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_LISTA}` },
  { name: 'Libros Electrónicos' },
  { name: 'Registro Compras' }
]

export const ValidationSchema = Yup.object().shape({
  mes: Yup.string().length(2).required()
})

const FormatoRegistroCompras = () => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      mes: __adminContext.mesTrabajo || '',
      flagDescargaExcel: false,
      flagSireExcel: false
    }
  }, [__adminContext])

  const onSubmit = React.useCallback(
    async formData => {
      await AsientoContableService.descargarLibroElectronicoRegistroCompras(formData)
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='Registro Compras' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          {__adminContext.mesTrabajo && (
            <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
              {({ errors, touched, isSubmitting, handleSubmit, values }) => (
                <Form>
                  <Row>
                    <Col md={6}>
                      <Row>
                        <Col md={6}>
                          <FormGroups.MesContabilidadFormGroup
                            iError={errors.mes}
                            iTouched={touched.mes}
                            fIsSubmitting={isSubmitting}
                          />
                          <FormGroups.FlagDescargaExcelFormGroup
                            fIsSubmitting={isSubmitting}
                            iValue={values.flagDescargaExcel}
                          />
                          <FormGroups.FlagSireExcelFormGroup
                            fIsSubmitting={isSubmitting}
                            iValue={values.flagSireExcel}
                          />
                        </Col>
                        <Col md={3}>
                          <Button disabled={isSubmitting} onClick={handleSubmit}>
                            {isSubmitting ? 'Descargando reporte ...' : 'Descargar'}
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          )}
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default React.memo(FormatoRegistroCompras)
